import styled from '@emotion/styled';
import { useLocation } from 'react-router-dom';

import { calixLogoSrc } from '@Calix-Commerce/design-system/assets';
import {
  Header as BaseHeader,
  HeaderContainer,
  HeaderTitle,
} from '@Calix-Commerce/design-system/components';

import { RepresentativeMenu, MainMenu } from './subcomponents';
import { ReactElement } from 'react';
import { Container } from '@Calix-Commerce/design-system';
import { TimedBanner } from 'components/TimedBanner';

const Title = styled(HeaderTitle)`
  font-size: 1.29rem;
`;

// Surcharge notice banner will be active from June 30th, 2026 at 5:00 AM PST with no end date.
const SURCHARGE_NOTICE_BANNER_DATES = {
  START: '2026-06-29T05:00:00.000-08:00',
};

const Header = (): ReactElement => {
  const { pathname } = useLocation();

  const showMenus = pathname !== '/accounts';

  return (
    <>
      <BaseHeader>
        <HeaderContainer>
          <img src={calixLogoSrc} alt="Calix Logo" />
          <Title>MY CALIX STORE</Title>
          {showMenus && (
            <>
              <RepresentativeMenu />
              <MainMenu />
            </>
          )}
        </HeaderContainer>
      </BaseHeader>
      <Container>
        <TimedBanner
          startDate={SURCHARGE_NOTICE_BANNER_DATES.START}
          type="warning"
          fixed={false}
          zIndex={0}
        >
          <strong>Memory Surcharge Update</strong>
          <p>
            As memory component costs continue to fluctuate, Calix has moved to monthly surcharge
            rates that will be applied at time of shipment. Refer to{' '}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.calix.com/my-calix/product-lead-times.html"
            >
              Product Order Lead Times
            </a>{' '}
            for the complete list. The applicable surcharge rate is determined at the time of
            shipment and is based on the published rate for that month.
          </p>
          <p>
            To provide greater pricing certainty, Calix offers the{' '}
            <strong>Calix Surcharge Assurance Program (CSAP)</strong>, which allows orders for
            eligible hardware products to be locked in at the surcharge rate in effect at the time
            of enrollment at both the order and line level. Eligibility for CSAP is subject to the
            CSAP Terms and Conditions{' '}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.calix.com/content/dam/calix/mycalix-misc/micro/CSAP.pdf"
            >
              Calix Surcharge Assurance Program
            </a>
            .
          </p>
          <p>
            If you have questions about memory surcharges, eligible products, or enrollment in the
            Calix Surcharge Assurance Program, please contact your Account Manager or the Customer
            Operations team at{' '}
            <a href="mailto:CalixCustomerOps@calix.com">CalixCustomerOps@calix.com</a>.
          </p>
          <p>Thank you for your continued trust in Calix.</p>
        </TimedBanner>
      </Container>
    </>
  );
};

export { Header };
